import React, { useContext, useEffect } from "react";

import DeviceContext from "~/Context/DeviceContext";
import StatisticsContent from "./Views/Track/Statistics/StatisticsContent";

const AppLayout = (props) => {
  const {
    windowWidth,
    windowHeight,
    isDevicePortrait,
    isDeviceCompact,
    isDeviceExpanded,
    isDeviceMedium,
    isDeviceMobile,
    isDeviceExtended,
  } = useContext(DeviceContext);

  useEffect(() => {
    const theme =
      localStorage.getItem("theme") !== null
        ? JSON.parse(localStorage.getItem("theme"))
        : "dark";

    if (theme === "dark") {
      document.getElementById("app").classList.add("ta-theme_dark");
      document.getElementById("app").classList.remove("ta-theme_light");
    } else {
      document.getElementById("app").classList.add("ta-theme_light");
      document.getElementById("app").classList.remove("ta-theme_dark");
    }
  }, []);

  useEffect(() => {
    if (isDevicePortrait === true) {
      document.getElementById("root").classList.add("is-portrait");
      document.getElementById("root").classList.remove("is-landscape");
    } else {
      document.getElementById("root").classList.remove("is-portrait");
      document.getElementById("root").classList.add("is-landscape");
    }

    if (isDeviceCompact === true) {
      document.getElementById("root").classList.add("is-compact");
    } else {
      document.getElementById("root").classList.remove("is-compact");
    }
    StatisticsContent;

    if (isDeviceMedium === true) {
      document.getElementById("root").classList.add("is-medium");
    } else {
      document.getElementById("root").classList.remove("is-medium");
    }

    if (isDeviceExpanded) {
      document.getElementById("root").classList.add("is-expanded");
    } else {
      document.getElementById("root").classList.remove("is-expanded");
    }

    if (isDeviceExtended) {
      document.getElementById("root").classList.add("is-extended");
    } else {
      document.getElementById("root").classList.remove("is-extended");
    }

    if (isDeviceMobile === true) {
      document.getElementById("root").classList.add("is-mobile");
    } else {
      document.getElementById("root").classList.remove("is-mobile");
    }
  }, [windowWidth, windowHeight]);

  return props.children;
};

export default React.memo(AppLayout);
